import { initialize } from "launchdarkly-js-client-sdk";
import { pluralize } from "./AnalyticsUtilities";
import { env } from "./env";
/* istanbul ignore next */
class LaunchDarklyEnvironment {
    #ldClient;
    #listeners = [];
    #flags = {};
    isReady = false;
    constructor() { }
    log(message, flags) {
        if (!env.getSilent()) {
            console.info(`%claunch darkly%c ${message}`, `
        background-color: darkslategray;
        color: white;
        border-radius: 10px;
        padding: 2px 5px;
        font-size: 90%;
       `, "font-weight: bold;", flags || this.#flags);
        }
    }
    boot(heaperIdentity) {
        const launchDarklyClientSideId = env.getLaunchDarklyClientSideId();
        if (!launchDarklyClientSideId) {
            throw new Error("Cannot boot Launch Darkly: client side id is not set!");
        }
        this.#ldClient = initialize(launchDarklyClientSideId, {
            kind: "heaper-identity",
            key: heaperIdentity.unique_identity,
            ...heaperIdentity,
        });
        this.#ldClient.on("initialized", () => {
            this.log(`Initialized for ${heaperIdentity.unique_identity}`);
        });
        this.#ldClient.on("failed", () => {
            this.log("Something went wrong!");
            console.error("Launch Darkly client failed to initialize!");
        });
        this.#ldClient.on("ready", this.updateFlags.bind(this));
        this.#ldClient.on("change", this.updateFlags.bind(this));
    }
    getClient() {
        return this.#ldClient;
    }
    subscribe(listener) {
        this.#listeners.push(listener);
        return () => {
            const idx = this.#listeners.findIndex((l) => l === listener);
            if (idx > -1) {
                this.#listeners.splice(idx, 1);
            }
        };
    }
    updateFlags() {
        const oldFlags = this.#flags;
        this.#flags = this.#ldClient ? this.#ldClient?.allFlags() : {};
        const flagKeyDiffs = Object.keys(this.#flags).filter((k) => this.#flags[k] !== oldFlags[k]);
        if (flagKeyDiffs.length) {
            const flagKeyChanges = {};
            flagKeyDiffs.map((k) => (flagKeyChanges[k] = this.#flags[k]));
            this.log(`Updated ${flagKeyDiffs.length} Feature ${pluralize(flagKeyDiffs.length, "Flag", "Flags")}`, flagKeyChanges);
            this.isReady = true;
            this.#listeners.forEach((listener) => listener());
        }
    }
    getFlags() {
        return this.#flags;
    }
}
export const createFeatureEnv = () => new LaunchDarklyEnvironment();
export const featureEnv = createFeatureEnv();
//# sourceMappingURL=featureEnv.js.map